import type { MarketVariants } from '@/lib/i18n'

export type Slide2PeterCopy = {
  quote: string
  attribution: string
  imageAlt: string
  /** Compliance label: Peter is a composite, not an attributed testimonial. */
  illustrative: string
}

// Peter's name is tied to his photo (assets/peter.png), so it is kept on the
// Qatar face and transliterated in Arabic rather than swapped for a local name.
export const copy: MarketVariants<Slide2PeterCopy> = {
  US: {
    quote:
      '“The moment they said my grandson was in trouble, my heart started racing. All my usual caution went out the window.”',
    attribution: 'Peter, retired engineer & victim of a grandparent scam',
    imageAlt: 'Peter',
    illustrative: 'Illustrative example',
  },
  ar: {
    quote:
      '"في اللحظة التي قالوا فيها إن حفيدي في ورطة، بدأ قلبي يخفق بسرعة. وتبخّر كل حذري المعتاد."',
    attribution: 'بيتر، مهندس متقاعد وضحية احتيال حالة طارئة عائلية',
    imageAlt: 'بيتر',
    illustrative: 'مثال توضيحي',
  },
}
